/* eslint-disable import/extensions */
/* eslint-disable react/forbid-prop-types */
import React from 'react'
import HaveSimCardDetail from '@apps/components/HaveSimCardDetail'
import NewESimDetail from '@apps/components/NewESimDetail'
import ConsumerESIMCompatibility from '@apps/components/ConsumerESIMCompatibility'
import GetNewPSimCard from '@apps/components/GetNewPSimCard'
import { useSelector } from 'react-redux'
import DealerESIMCompatibility from '@apps/components/DealerESIMCompatibility'
import SimPurchaseUnavailable from '@apps/components/SimPurchaseUnavailable'
import PropTypes from 'prop-types'
import { CONSUMER_SIM_OPTIONS, SIM_OPTIONS } from '@apps/utils/constants'
import Sites from '@sites/index'

const SimSelectionDetails = ({
  userType,
  simSelection,
  selectedSimType,
  autoLookupIMEI,
  onESimContinue,
  onChoosePSim,
  eSimContinueLabel,
  eSimContinueTestId,
  dealerEIDValue,
  dealerEIDError,
  onDealerEIDValueChange,
  simRef
}) => {
  const { featureFlags } = useSelector((state) => state.common.content)

  const eSimPurchaseAvailable = featureFlags && featureFlags[0]?.eSimPurchaseAvailable

  const havePhysicalSIMSelection = () => {
    return simSelection === CONSUMER_SIM_OPTIONS.HAVE_SIM || simSelection === SIM_OPTIONS.H_SIM
  }

  const consumerESIMSelection = () => {
    return simSelection === CONSUMER_SIM_OPTIONS.NEW_SIM && selectedSimType !== SIM_OPTIONS.P_SIM
  }

  const buyPhysicalSIMSelection = () => {
    return userType !== Sites.dealer &&
      selectedSimType === SIM_OPTIONS.P_SIM &&
      !havePhysicalSIMSelection()
  }

  const dealerESIMSelection = () => {
    return simSelection === SIM_OPTIONS.E_SIM
  }

  if ((consumerESIMSelection() || dealerESIMSelection()) && !eSimPurchaseAvailable) {
    return <SimPurchaseUnavailable userType={userType} />
  }

  return (
    <>
      {havePhysicalSIMSelection() && <HaveSimCardDetail userType={userType} simRef={simRef} />}
      {consumerESIMSelection() && (
        selectedSimType ? (
          <ConsumerESIMCompatibility
            autoLookup={autoLookupIMEI}
            continueLabel={eSimContinueLabel}
            continueTestId={eSimContinueTestId}
            onCompatibleContinue={onESimContinue}
            onChoosePSim={onChoosePSim}
            showTopBorder={false}
          />
        ) : (
          <NewESimDetail userType={userType} />
        )
      )}
      {buyPhysicalSIMSelection() && <GetNewPSimCard userType={userType} />}
      {dealerESIMSelection() && (
        <DealerESIMCompatibility
          userType={userType}
          eidValue={dealerEIDValue}
          eidError={dealerEIDError}
          onEIDValueChange={onDealerEIDValueChange}
        />
      )}
    </>
  )
}

SimSelectionDetails.propTypes = {
  userType: PropTypes.string.isRequired,
  simSelection: PropTypes.string.isRequired,
  selectedSimType: PropTypes.string,
  autoLookupIMEI: PropTypes.bool,
  onESimContinue: PropTypes.func,
  onChoosePSim: PropTypes.func,
  eSimContinueLabel: PropTypes.string,
  eSimContinueTestId: PropTypes.string,
  dealerEIDValue: PropTypes.string,
  dealerEIDError: PropTypes.string,
  onDealerEIDValueChange: PropTypes.func,
  simRef: PropTypes.object.isRequired
}

export default SimSelectionDetails
